import "./chart-setup";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create the React Query client instance
const queryClient = new QueryClient();

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#DD7112FF", // MUI default blue
    },
    background: {
      default: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  components: {
    // Style for all buttons
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 500,
          boxShadow: "none",
          padding: "6px 16px",
          transition: "all 0.2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          },
        },
        contained: {
          boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
          },
        },
      },
    },
    // Style for all icon buttons
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: "all 0.2s ease",
          padding: "8px",
          borderRadius: "8px",
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
          },
        },
      },
    },
    // Style for tooltips
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
          fontSize: "0.75rem",
          padding: "6px 10px",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
        arrow: {
          color: "rgba(0, 0, 0, 0.8)",
        },
      },
      defaultProps: {
        arrow: true,
      },
    },
  },
});

const container = document.getElementById("root");

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={lightTheme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
} else {
  console.error("❌ Root element not found.");
}
